import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { EmergencyAnswerAction, EmergencyAnswerGetter } from '@/store/emergencyAnswer/emergencyAnswer.module';
import { EmergencyAnswer, EmergencyAnswerAttachment } from '@/store/emergencyAnswer/emergencyAnswer.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'EmergencyAnswerAttachmentModelComponent',
  components: {
    BaseModalComponent
  },
  props: {
    emergencyId: {
      type: Number,
    },
    emergencyAnswerId: {
      type: Number,
    }
  },
  emits: [
    'upload',
    'hidden',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const emergencyAnswer = computed<EmergencyAnswer>(() => store.getters[EmergencyAnswerGetter.BY_ID](props.emergencyAnswerId));
    const attachments = computed<EmergencyAnswerAttachment[]>(() => (emergencyAnswer.value) ? emergencyAnswer.value?.emergencyAnswerAttachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[EmergencyAnswerGetter.STATUS] === 'init' || store.getters[EmergencyAnswerGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', emergencyAnswer.value?.id);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(EmergencyAnswerAction.REMOVE_ATTACHMENTS, {
              emergencyId: props.emergencyId,
              id: emergencyAnswer.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    // hidden
    const handleHidden = () => {
      context.emit('hidden', emergencyAnswer.value?.id);
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
      handleHidden,
    };
  },
});
